import { render, staticRenderFns } from "./OrganizationSeal.vue?vue&type=template&id=3f4d5c97&scoped=true"
import script from "./OrganizationSeal.vue?vue&type=script&lang=js"
export * from "./OrganizationSeal.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSeal.vue?vue&type=style&index=0&id=3f4d5c97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4d5c97",
  null
  
)

export default component.exports